$.extend(true, $.fancybox.defaults, {
    padding : 40,

    'tpl': {
        'closeBtn': '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"><svg class="icon" focusable="false"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/images/icons.svg#streamplus-remove-circle-1"></use></svg></a>'
    }
});
